import { render, staticRenderFns } from "./mcpEdit.vue?vue&type=template&id=64b256c6&scoped=true"
import script from "./mcpEdit.vue?vue&type=script&lang=js"
export * from "./mcpEdit.vue?vue&type=script&lang=js"
import style0 from "./mcpEdit.vue?vue&type=style&index=0&id=64b256c6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b256c6",
  null
  
)

export default component.exports